/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LobbyModel } from '../../models/lobby-model';

export interface LobbyIdGet$Params {
  id: string;
}

export function lobbyIdGet(http: HttpClient, rootUrl: string, params: LobbyIdGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<LobbyModel>> {
  const rb = new RequestBuilder(rootUrl, lobbyIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<LobbyModel>;
    })
  );
}

lobbyIdGet.PATH = '/Lobby/{id}';
